import React from 'react';

import Radio from '../../../design-system/Radio/Radio';
import FormFieldWrapper from '../../../design-system/FormFieldWrapper/FormFieldWrapper';

const SingleSelectContentPiece = ({
    id,
    value,
    options,
    label,
    state,
    editable,
    logFeedbackTrigger,
    setFormData,
    setErrorFormFields,
}) => {
    const handleSingleSelectChange = (id, value) => {
        setFormData((prevData) =>
            prevData.map((item) => (item.id === id ? { ...item, value } : item))
        );
        setErrorFormFields((errorFields) => {
            if (errorFields?.[id]) {
                return { ...errorFields, [id]: false };
            }
            return errorFields;
        });
    };

    return (
        <FormFieldWrapper
            label={<strong>{label}</strong>}
            showLabelAsBadge
            state={state}
            errorMessage="Please select an option"
            gap={6}
            actionsBarRightContent={logFeedbackTrigger}
        >
            <ul className="flex flex-col gap-1">
                {Object.entries(options)?.map(([key, optionValue], index) => (
                    <div key={index} className="py-1 px-2">
                        <Radio
                            isSelected={optionValue === value}
                            name={optionValue}
                            onChange={() => handleSingleSelectChange(id, optionValue)}
                            label={key}
                            state={!editable ? 'disabled' : 'default'}
                        />
                    </div>
                ))}
            </ul>
        </FormFieldWrapper>
    );
};

export default SingleSelectContentPiece;
